import React from 'react';

import Parametrage from '../../components/NewDashboard/Parametrage';

function ParametrageView() {
  return (
    <Parametrage />
  );
}

export default ParametrageView; 